var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('textarea',{ref:"copy_to_clipboard_textarea",staticStyle:{"position":"absolute","left":"-9999px","top":"-9999px"}}),_c('v-btn',{attrs:{"icon":"","large":_vm.large},on:{"click":function($event){return _vm.copy()}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-content-copy")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }